@if (vm.isLoading) {
  <app-skeleton-loader class="dark h-40 sm-h-32 fill max-w-420" />
  <app-skeleton-loader class="dark h-24 sm-h-32 mt-12 sm-mt-8 fill max-w-220" />
} @else {
  <h1 class="heading-1">
    {{ vm.planDetails.headingDisplay | firstLetterCapitalise }}
  </h1>
  <p class="body large mt-4">Check your bookings here or get in touch if you need help.</p>
}
